// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AA x2","wrapperNeon":"AB yc","addMyListButton":"AC ya"};